import { LitElement, html, css } from "lit-element";

// language=CSS
export const InputCheckboxStyle = css`
	:host {
		display: flex;
		width: 100%;
	}

	:host label > input[type="radio"],
	:host label > input[type="checkbox"] {
		display: none;
	}

	:host label {
		display: block;
		font-size: 14px;
		position: relative;
		border-radius: 2px;

		line-height: 20px;
	}

	:host label > input-md-decorator {
		-ms-flex: 1 1 0.000000001px;
		-webkit-flex: 1;
		flex: 1;
		-webkit-flex-basis: 0.000000001px;
		flex-basis: 0.000000001px;
		padding: 5px 20px 5px 30px;
		display: block;
		cursor: pointer;
		line-height: 20px;
	}

	:host label > input[type="radio"] + input-md-decorator::after,
	:host label > input[type="checkbox"] + input-md-decorator::after {
		font-weight: bold;
		content: "";
		display: block;
		position: absolute;

		left: 0;
		top: 5px;
		height: 16px;
		width: 16px;

		padding: 2px;

		transition: opacity 0.1s;
		will-change: opacity;

		border: var(--input-checkbox-border-size, 3px) solid var(--input-checkbox-border-color, var(--app-accent));
		border-radius: var(--input-checkbox-radius, 3px);

		background-repeat: no-repeat;
	}

	:host label > input[type="radio"]:checked + input-md-decorator::after,
	:host label > input[type="checkbox"]:checked + input-md-decorator::after {
		background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='var%28--app-accent%29' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath d='M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z'/%3E%3C/svg%3E");
		background-position: center;
		background-size: 16px;
		border: var(--: host-border-size, 3px) solid var(--input-checkbox-border-color-checked, var(--app-accent));
	}

	:host[filled] label > input[type="radio"]:checked + input-md-decorator::after,
	:host[filled] label > input[type="checkbox"]:checked + input-md-decorator::after {
		background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23FFFFFF' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath d='M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z'/%3E%3C/svg%3E");
		background-position: center;
		background-size: 16px;
		background-color: var(--app-accent);
	}
`;

export class StofwareInputCheckbox extends LitElement {
	static get properties() {
		return {
			name: { type: String },
			label: { type: String },
			checked: { type: Boolean },
			disabled: { type: Boolean }
		};
	}

	static get styles() {
		return InputCheckboxStyle;
	}

	render() {
		return html`
			<label>
				<input type="checkbox" name="${this.name}" ?checked="${this.checked}" ?disabled="${this.disabled}" />
				<input-md-decorator><strong>${this.label}</strong></input-md-decorator>
			</label>
		`;
	}
}

customElements.define("input-checkbox", StofwareInputCheckbox);
